export const deprecate = (thing, message = 'This will be removed') => {
  console.warn(`DEPRECATION WARNING: ${message}`);
  return thing;
};
